import * as React from 'react';

import { ITargetCheckSettingsState } from './types';

import API from 'src/services/api';
import { useMounted } from 'src/services/hooks/useMounted';

const { useEffect, useReducer, useCallback } = React;

const settingsReducer = (state: ITargetCheckSettingsState, action: any) => {
  switch (action.type) {
    case 'FETCH_SETTINGS':
      return {
        ...state,
        isFetching: true,
      };
    case 'SET_SETTINGS':
      return {
        ...state,
        ...action.payload,
        isFetching: false,
      };
    case 'TOGGLE_OPEN':
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    case 'TOGGLE_ACTIVE':
      return {
        ...state,
        isActive: !state.isActive,
      };
    case 'SET_DATE_FROM':
      return {
        ...state,
        dateFrom: action.payload,
      };
    case 'SET_DATE_TO':
      return {
        ...state,
        dateTo: action.payload,
      };
    case 'SAVE_INIT':
      return {
        ...state,
        isSaving: true,
        savingError: false,
      };
    case 'SAVE_SUCCESS':
      return {
        ...state,
        isSaving: false,
        isOpen: false,
      };
    case 'SAVE_ERROR':
      return {
        ...state,
        isSaving: false,
        savingError: true,
      };
    default:
      return new Error('Target check settings: action not permitted');
  }
};

const initialSettings: ITargetCheckSettingsState = {
  isFetching: true,
  isSaving: false,
  savingError: false,
  isOpen: false,
  isActive: false,
  dateFrom: new Date(),
  dateTo: new Date(),
};

export const useSettings = (id: number) => {
  const [settings, dispatch] = useReducer(settingsReducer, initialSettings);
  const isMounted = useMounted();

  const dispatchIfMounted = useCallback(
    (action: any) => {
      if (isMounted) {
        dispatch(action);
      }
    },
    [isMounted]
  );

  useEffect(() => {
    const { getData, cancel } = API.LINK.TARGET_CHECK.getSettings(id);
    async function fetch() {
      dispatch({ type: 'FETCH_SETTINGS' });
      const data = await getData();
      dispatch({ type: 'SET_SETTINGS', payload: data });
    }
    fetch();
    return cancel;
  }, [id]);

  async function saveSettings() {
    const { getData } = API.LINK.TARGET_CHECK.updateSettings(id, settings);
    dispatch({ type: 'SAVE_INIT' });
    try {
      await getData();
      dispatchIfMounted({ type: 'SAVE_SUCCESS' });
    } catch (error) {
      dispatchIfMounted({ type: 'SAVE_ERROR' });
    }
  }

  const toggleOpen = () => dispatch({ type: 'TOGGLE_OPEN' });
  const toggleActive = () => dispatch({ type: 'TOGGLE_ACTIVE' });
  const setDate = (type: string) => (date: Date) =>
    dispatch({ type: `SET_${type}`, payload: date });

  return {
    settings,
    actions: { saveSettings, toggleOpen, toggleActive, setDate },
  };
};



// WEBPACK FOOTER //
// ./src/components/TargetCheck/useSettings.ts